import axios from "./AxiosInstance"

const getList = () => axios.get("api/microGoals")

const getDetail = (id) => axios.get(`api/microGoals/${id}`)

const create = (data) => axios.post("api/microGoals", data)

const update = (id, data) => axios.put(`api/microGoals/${id}`, data)

const remove = (id) => axios.delete(`api/microGoals/${id}`)

const updateStatus = (id, data) => axios.put(`api/microGoals/${id}/status`, data)

const getStatusHistory = (id) => axios.get(`api/microGoals/${id}/statusHistory`)

export const MicroGoalService = {
    getList,
    getDetail,
    create,
    update,
    remove,
    updateStatus,
    getStatusHistory
}
